exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\ninput[data-v-d8862f8e] {\n  background-color: #f5f8fa;\n}\n.total-value[data-v-d8862f8e] {\n  font-size: 3rem;\n}\n.total-price-min-height[data-v-d8862f8e] {\n  min-height: 5.8rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-d8862f8e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/ProductEditPrice.vue
// module id = 1581
// module chunks = 0